const MoreAboutAB = ()=> <div>Table.js</div>

export default MoreAboutAB